import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import LiabilityAccountLayout from './LiabilityAccountLayout';
import EmployerSponseredAccountLayout from './EmployerSponseredAccountLayout';
import AccordionLayout from './AccountAccordion';
import BankAccountLayout from './BankAccountLayout';
import PersonalRetirementLayout from './PersonalRetirementAccount';
import EducationLayout from './EducationAccountLayout';
import NonRetirementLayout from './NonRetirementAccountLayout';


export const LAYOUTS = {
  education_account: EducationLayout,
  non_retirement_account: NonRetirementLayout,
  employer_sponsored_plan: EmployerSponseredAccountLayout,
  liability: LiabilityAccountLayout,
  bank_account: BankAccountLayout,
  personal_retirement_account: PersonalRetirementLayout,
  health_savings_account: NonRetirementLayout,
};

function AccountForm({ resource, classes, LayoutProps }) {
  return (
    <MetaFormInline
      noIndividualSubmitButtons
      classes={classes}
      resource={resource}
      layout={AccordionLayout}
      LayoutProps={LayoutProps}
    />
  );
}

AccountForm.propTypes = {
  LayoutProps: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
};

export default withStyles({
  root: {
    padding: 0,
  },
})(AccountForm);
